import { useMutation } from 'react-query';
import axios from 'axios';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { QueueItemIconMedia } from '../../../types/Admin/ItemIconTypes';

export const useUploadCategoryChildrenIcon = (categoryId?: number | null) => {
  const { mutateAsync: uploadCategoryChildrenIcon, isLoading: isUploadCategoryChildrenIconLoading } =
    useMutation(async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const url = categoryId
        ? CategoriesTopicsTableAPI.uploadCategoryChildrenIcon(categoryId)
        : CategoriesTopicsTableAPI.uploadPendingCategoryChildrenIcon;
      const response = await axios.post<QueueItemIconMedia>(url, formData, multipartHeaders());
      return response.data.url;
    });

  return { uploadCategoryChildrenIcon, isUploadCategoryChildrenIconLoading };
};
